
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'LoginAsUser',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
      }
   },
   methods: {
      async action() {
         this.processing = true
         try {
            await Api.loginAsUser(this.editingItem.Id)
            ;(window as any).location = '/Profile'
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      SaveButton,
   },
})
